// VzmNumberField.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
import React, { useState } from "react";
import { TextField } from "@mui/material";
import { AppWord, InputType } from "../value/AppConst";
import IsValid from "../value/IsValid";

/**
 * Input field for integer.
 * Uses input dictionary to determine its behavior.
 */
export default function VzmNumberField({
    dict,
    value,
    disabled,
    onChange,
    onEnterKey,
    onFocused,
    fullWidth,
    inputProps,
    size,
}) {
    const [error, setError] = useState(false);
    
    const onChangeValue = (e) => {
        const text = e.target.value;
        let error = false;
        if(IsValid.nullString(text)) {
            if(dict.required) error = true;
            setError(error);
            onChange(dict.id, null, error);
            return;
        }

        const num = parseFloat(text);
        if(dict.check) {
            error = !dict.check(num);
            setError(error);
        }
        else {
            if(dict.min !== undefined && dict.min !== null) {
                error = num < dict.min;
            }
            if(!error && dict.max !== undefined && dict.max !== null) {
                error = num > dict.max;
            }
            setError(error);
        }

        onChange(dict.id, num, error);
    };

    return(
        <TextField id={dict.id} size={size || dict.size || AppWord.SMALL}
            fullWidth={fullWidth}
            type={InputType.number}
            label={dict.label}
            required={dict.required}
            value={value ? value : value===0 ? 0 : ''}
            error={error}
            placeholder={dict.placeholder ? dict.placeholder : undefined}
            helperText={dict.errorHelp ? dict.errorHelp : undefined}
            onChange={onChangeValue}
            onFocus={()=>{if(onFocused) onFocused(dict)}}
            inputProps={inputProps}
            disabled={disabled?true:false}
            onKeyDown={(e)=>{
                if(e.key==='Enter' && onEnterKey) onEnterKey();
            }}
            />
    );
}
